import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import Loading from "../../components/Loading";
import {
  DashboardOverview,
  DashboardSegment,
  getOverview,
} from "../../services/dashboardService";
import StatCard from "./components/StatCard";
import SegmentSection from "./components/SegmentSection";

const SEGMENTS: {
  segment: DashboardSegment;
  title: string;
  description: string;
}[] = [
  {
    segment: "streak-at-risk",
    title: "Streak at Risk",
    description: "About to lose their workout streak",
  },
  {
    segment: "trials-ending-48h",
    title: "Trials Ending in 48 Hours",
    description: "Free trials expiring soon",
  },
  {
    segment: "inactive-7d",
    title: "Inactive Premium (7+ Days)",
    description: "Paying members who haven't logged in for a week",
  },
  {
    segment: "worked-out-today",
    title: "Worked Out Today",
    description: "Completed a workout today",
  },
  {
    segment: "worked-out-this-week",
    title: "Worked Out This Week",
    description: "Completed a workout this week",
  },
  {
    segment: "first-workout",
    title: "First Workout",
    description: "Just completed their first-ever workout",
  },
  {
    segment: "all-active-subscriptions",
    title: "All Active Subscriptions",
    description: "Every member with an active subscription",
  },
  {
    segment: "all-cancelled-subscriptions",
    title: "All Cancelled Subscriptions",
    description: "Every member with a cancelled subscription",
  },
];

const MemberSuccessDashboard: React.FC = () => {
  const [overview, setOverview] = useState<DashboardOverview | null>(null);
  const [overviewLoading, setOverviewLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setOverviewLoading(true);
      const result = await getOverview();
      setOverview(result);
      setOverviewLoading(false);
    })();
  }, []);

  return (
    <div className="p-4 md:p-6 bg-gray-100 min-h-screen">
      <Header title="Member Success Dashboard" />

      {overviewLoading ? (
        <Loading message="Loading overview..." />
      ) : overview ? (
        <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
          <StatCard
            label="Active Users Today"
            stat={overview.activeUsersToday}
          />
          <StatCard
            label="Workouts Completed Today"
            stat={overview.workoutsCompletedToday}
          />
          <StatCard
            label="Members at Risk"
            stat={overview.membersAtRisk}
            goodDirection="down"
          />
          <StatCard
            label="Inactive Premium (7d)"
            stat={overview.inactivePremium7d}
            goodDirection="down"
          />
          <StatCard
            label="Trials Ending (48h)"
            stat={overview.trialsEnding48h}
            goodDirection="down"
          />
        </div>
      ) : (
        <p className="mb-6 text-sm text-red-600">
          Could not load overview stats.
        </p>
      )}

      <div>
        {SEGMENTS.map((s) => (
          <SegmentSection
            key={s.segment}
            segment={s.segment}
            title={s.title}
            description={s.description}
          />
        ))}
      </div>
    </div>
  );
};

export default MemberSuccessDashboard;
